import { ComponentProps } from "react";

const SpeedometerIcon = (props: ComponentProps<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.85"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.2 19a9 9 0 1 1 15.6 0H4.2Z" />
    <path d="M5 12h1.5M7 7l1 1M12 5v1.5M17 7l-1 1M19 12h-1.5M13.1 13.9 16 11" />
    <circle cx="12" cy="15" r="1.5" />
  </svg>
);

export default SpeedometerIcon;
